<div class="po-component-container calc-width">
  <div class="d-flex mt-1 mb-2"
    [ngClass]="{ 'justify-content-end': !isMobileScreen(), 'justify-content-center': isMobileScreen() }">
    <mat-card>
      <mat-card-content>
        <div class="d-flex align-items-center">
          <p class="mb-0 me-3">
            <span class="text-weight">Non Released Items: </span>{{ getNonReleasedItemCount() }}
          </p>
          <p class="mb-0 me-3">
            <span class="text-weight">Non Checked Orders: </span>{{ getNonCheckedOrderCount() }}
          </p>
          <!-- Counter view: what has been made and is waiting to be handed over. -->
          @if (counterService) {
            <button nz-button nzSize="small"
              [nzType]="readyForPickupOnly ? 'primary' : 'default'"
              (click)="toggleReadyForPickup()">
              Ready for pickup ({{ getReadyForPickupCount() }})
            </button>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="orders-grid mt-3">
    @for (item of sortedItems; track item) {
      <div class="order-card"
        [ngClass]="{'preparing-border': checkOrderStatus(item.cartResponseDetails) == orderStatus.Preparing,
        'released-border': checkOrderStatus(item.cartResponseDetails) == orderStatus.Released || checkOrderStatus(item.cartResponseDetails) == orderStatus.Served }">

        <!-- Order Header -->
        <div class="order-header">
          <div class="header-top">
            <div class="d-flex align-items-center gap-2">
              <label nz-checkbox [ngModel]="checkOrderStatus(item.cartResponseDetails)!=orderStatus.Placed"
                (ngModelChange)="updateOrderStatus(item)"></label>
              <div class="table-badge" nz-tooltip [nzTooltipTitle]="titleTemplate">
                {{ tableName(item.tables) | truncate: 15 }}
              </div>
              <ng-template #titleTemplate>
                @for (table of item.tables; track table; let i = $index) {
                  <div>
                    {{ table | tableName : tables }}
                    @if (i !== item.tables.length - 1) { <span>,</span> }
                  </div>
                }
              </ng-template>
            </div>
            <div class="header-meta-right">
              <span [nz-tooltip]="item.sectionName">{{ item.sectionName | truncate: 20 }}</span>
              <span class="meta-time">{{ item.createdAt | date : "dd/MM HH:mm" }}</span>
            </div>
          </div>
          <div class="header-main">
            <h4 class="order-number">{{ item.orderNumber }}</h4>
            <span class="order-total">Items {{ item.cartResponseDetails.length | number }}</span>
          </div>
          <div class="header-meta">
            <span>
              {{ orderTypes[item.orderType] | capitalize }} | {{ orderStatus[item.orderingStatus] | capitalize }}
              <!-- Payment is a separate track: a counter order is Paid while still being made. -->
              @if (item.paymentStatus === paymentStatus.Paid) {
                <nz-tag nzColor="success">Paid</nz-tag>
              } @else if (item.paymentStatus === paymentStatus.Partial) {
                <nz-tag nzColor="warning">Partial</nz-tag>
              }
            </span>
            <span>{{ item.createdByName }}</span>
          </div>
        </div>

        <!-- Food Items -->
        <div class="order-body">
          @for (foodItem of sortOrderItems(item.cartResponseDetails); track foodItem) {
            <div class="food-item-row">
              <div class="food-item-top">
                <div class="food-item-left">
                  <span class="food-name">{{ foodItem.foodId | foodItemName: foodItems }}</span>
                  <span class="food-qty">x{{ foodItem.quantity }}</span>
                </div>
                <div class="food-item-right">
                  @if (foodItem.cartStatus !== 4) {
                    <span class="food-time">{{ getElapsedTime(foodItem.createdAt) }}</span>
                  }
                  <!-- The switch only reports "is it made?" — a boolean cannot carry the
                       Served step, so that is an explicit action beside it. -->
                  <nz-switch
                    [ngModel]="foodItem.cartStatus === orderStatus.Released || foodItem.cartStatus === orderStatus.Served"
                    [disabled]="foodItem.cartStatus === orderStatus.Placed
                      || (counterService ? foodItem.cartStatus >= orderStatus.Released
                                         : foodItem.cartStatus === orderStatus.Served)"
                    (ngModelChange)="onStatusChange(foodItem, item.orderId, item.tables)"
                    [nzCheckedChildren]="foodItem.cartStatus === orderStatus.Released ? 'Released'
                      : foodItem.cartStatus === orderStatus.Served ? 'Served' : null"
                    [nzUnCheckedChildren]="foodItem.cartStatus === orderStatus.Placed ? 'Placed'
                      : foodItem.cartStatus === orderStatus.Preparing ? 'Preparing': null">
                  </nz-switch>

                  @if (counterService && foodItem.cartStatus === orderStatus.Released) {
                    <button nz-button nzType="primary" nzSize="small"
                      (click)="onStatusChange(foodItem, item.orderId, item.tables)">
                      Serve
                    </button>
                  }
                  @if (counterService && canSendBack(foodItem)) {
                    <button nz-button nzType="default" nzDanger nzSize="small"
                      nz-tooltip nzTooltipTitle="Wrong item — send back to be remade"
                      (click)="sendBack(foodItem, item.orderId, item.tables)">
                      Send back
                    </button>
                  }
                </div>
              </div>
              <div class="food-item-details">
                @if (!isNameContainsSpecialCharacter(foodItem.foodId)) {
                  <small class="qty-tag">{{ foodItem.foodQuantityTagId! | quantityTagName: foodItemQuantity }}</small>
                }
                @if (foodItem.extras && foodItem.extras.length > 0) {
                  <small class="extras-text">
                    @for (data of foodItem.extras; track data; let i = $index) {
                      {{ data | extraFoodName: foodExtras }}@if (i !== foodItem.extras.length - 1) {, }
                    }
                  </small>
                }
                @if (foodItem.kitchenIntroduction) {
                  <small class="kitchen-note">{{ foodItem.kitchenIntroduction }}</small>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
